// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionFeatured_root__euV5Y","title":"SectionFeatured_title__eQA2y","images":"SectionFeatured_images__1tLbe","image":"SectionFeatured_image__34xKr"};